import { Select } from 'antd';
import { ISelectOption } from 'components/common/Select/types';
import { getBankDetailsSelectProps } from './BankDetailsSelectField';

interface BankDetailsAddressSelectProps {
  placeholder: string;
  options: ISelectOption[];
  addresses: { fullAddress: string }[];
  value: string;
  disabled?: boolean;
  onSelect: (address: unknown, selectedValue: string) => void;
}

export function BankDetailsAddressSelect({
  placeholder,
  options,
  addresses,
  value,
  disabled = false,
  onSelect,
}: BankDetailsAddressSelectProps) {
  return (
    <Select
      placeholder={placeholder}
      disabled={disabled}
      showSearch={false}
      {...getBankDetailsSelectProps(disabled)}
      options={options.map(option => ({ label: option.label, value: option.value }))}
      value={value || undefined}
      onChange={optionValue => {
        const found = addresses.find(address => address.fullAddress === optionValue);
        if (found) {
          onSelect(found, String(optionValue));
        }
      }}
    />
  );
}
